export default "__VITE_ASSET__DDdo8cik__"